import styled from '@emotion/styled';
import { Box } from '@mui/material';

export const ContentsWrapper = styled(Box)`
  width: 100%;
  height: 100%;
  display: flex;
`;
